import React from "react";
import { color } from "./constants";

const Radio = (props) => {
  return (
    <label
      style={{
        position: "relative",
        margin: props.labelMargin || "0 10px 0 0",
        opacity: props.disabled ? 0.3 : 1,
        ...props.labelStyle,
      }}
      className='lblRadio'
    >
      <input
        type="radio"
        value={props.value}
        checked={props.checked}
        onChange={props.handleChange}
        style={{ opacity: 0, margin: props.inputMargin || "0 10px 0 0" }}
        name={props.name}
        tabIndex={props.tab}
        disabled={props.disabled}
        readOnly={props.readOnly}
        defaultChecked={props.defaultChecked}
      />
      <span
        style={{
          position: "absolute",
          left: "0px",
          top: "0",
          width: "15px",
          height: "15px",
          border: "2px solid ",
          borderColor: props.borderColor || color.blue,
          borderRadius: "50%",
          background: color.white,
        }}
        className={`${props.checked ? 'rdoOuterChecked' : 'rdoOuterUnchecked'}`}
      ></span>
      <span
        style={{
          position: "absolute",
          left: "4px",
          top: "4px",
          width: "7px",
          height: "7px",
          background: props.checked ? color.blue : "#fff",
          borderRadius: "50%",
          zIndex: 2,
        }}
        className={props.checked ? 'checked' : ''}
      ></span>
      <span className='showvalue'>{props.showValue}</span>
    </label>
  );
};

export default Radio;
